<template>
    <div class="project-card card">
        <div class="card-header">
            <div class="name">
                <inertia-link :href="route('project.details', {project: project.id, ...global_url_params})"
                              class="text-decoration-none">{{ project.name }}</inertia-link>
            </div>
            <div class="actions">
                <a href="#" @click.prevent.stop="showSettings()">
                    <img src="/images/icons/cog.svg" alt="">
                </a>
            </div>
        </div>
        <div class="card-body p-0">


            <div v-if="showInfo" class="info">
                <dl class="theme">
                    <dt>Goal</dt>
                    <dd>{{ theme.name }}</dd>
                </dl>
                <dl class="path">
                    <dt>Learning Path</dt>
                    <dd>{{ project.learning_path?.name }}</dd>
                </dl>
            </div>

            <div v-if="is_admin && showMoreInfo" class="info">
                <div class="flex-grow-1">
                    <strong>{{ project.organization ? project.organization.name : 'Personal Project' }}</strong>
                    - {{ creatorName( project ) }}
                </div>
            </div>

            <div v-if="showTeams" class="teams px-3 py-3">
                <a v-for="team in project.teams"
                   href="#"
                   @click.prevent.stop=""
                   class="team">
                    <name-icon :value="team"/>
                </a>

                <a v-if="manageTeams"
                   class="add-team"
                   href="#"
                   @click.prevent.stop="$emit('add-team')">
                    <img src="/images/icons/icon-users-cog.svg" alt="">
                </a>

            </div>

        </div>
        <div  v-if="showFooter" class="card-footer d-flex">
<!--            <div class="btn-group">-->
<!--                <inertia-link :href="route('project.learning-path', {project: project.id, ...global_url_params})"-->
<!--                              class="btn btn-outline-primary">Learning Path</inertia-link>-->
<!--                <inertia-link :href="route('project.teams', {project: project.id, ...global_url_params})"-->
<!--                              class="btn btn-outline-primary">Teams</inertia-link>-->
<!--                <inertia-link :href="route('project.show', {project: project.id, ...global_url_params})"-->
<!--                              class="btn btn-outline-primary">Progress</inertia-link>-->
<!--            </div>-->

            <inertia-link :href="route('project.details', {project: project.id, ...global_url_params})"
                          class="btn btn-outline-primary">Open Project</inertia-link>

            <inertia-link :href="route('project.teams', {project: project.id, ...global_url_params})"
                          class="btn btn-outline-secondary ml-auto">View Teams</inertia-link>

        </div>

        <project-settings-modal
            :id="utils.randomId({prefix:'project-settings'})"
            v-if="settings_modal.enabled"
            :show="settings_modal.enabled"
            :project="project"
            :show-delete="true"
            :show-clone="showClone"
            @cloned="$emit('cloned', $event)"
            @close="settings_modal.enabled = false"/>

    </div>
</template>

<script>
import themes from "@/DATA/themes";
import utils from "@/mixins/utils";
import NameIcon from "@/Components/Team/NameIcon";
import ProjectSettingsModal from "@/Components/Project/ProjectSettingsModal";
import StateButton from "@/Components/Common/StateButton";
import API from "@/API";

export default {
    name: "ProjectCard",
    components: {StateButton, NameIcon, ProjectSettingsModal},
    mixins: [utils],

    emits: ['cloned'],

    props: {
        project: {
            type: [Object, null],
            default(){
                return null;
            }
        },
        showInfo: {
            type: Boolean,
            default: true
        },
        showMoreInfo: {
            type: Boolean,
            default: false
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        showTeams: {
            type: Boolean,
            default: true
        },
        manageTeams: {
            type: Boolean,
            default: true
        },
        showDelete: {
            type: Boolean,
            default: false,
        },
        showClone: {
            type: Boolean,
            default: false,
        }
    },


    data(){
        return {
            is_busy: false,
            is_cloning: false,

            settings_modal: {
                enabled: false,
            }
        }
    },

    computed: {
        theme(){
            return themes.reduce((prev, val) => val.id == this.project.theme ? val : prev, {id: 0, name: 'Unknown', slug: 'unknown'});
        },
    },


    methods: {

        showSettings(){
            this.settings_modal.enabled = true;
        },

        creatorName( project ){
            if( project?.created_by?.name ){
                return project.created_by.name;
            }
            return 'Unknown';
        }

    }

}
</script>

<style lang="scss" scoped>
.card-header{
    display: flex;

    .name{
        font-size: 18px;
        font-weight: $font-weight-bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .actions{
        margin-left: auto;
    }

}

.info{
    display: flex;
    flex-direction: column;
    border-bottom: $light-borders solid 1px;

    @include media-breakpoint-up(md) {
        flex-direction: row;
    }

    > * {
        padding: 0.8rem 1.2rem;
        flex: 0 0 50%;
    }

    .theme{
        border-bottom: $light-borders solid 1px;

        @include media-breakpoint-up(md) {
            border-bottom: none;
            border-right: $light-borders solid 1px;
        }
    }

    dl, dd{
        margin-bottom: 0;
    }
}

.teams{
    display: flex;
    margin-left: 8px;

    .team{
        margin-left: -8px;
        text-decoration: none;
    }

    .add-team{
        color: white;
        padding: 0.4rem;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: $font-weight-bold;
        border: white solid 2px;
        box-shadow: $box-shadow-sm;
        text-decoration: none;
        background: #20CE83;
        margin-left: auto;
    }
}

.card-footer {
    gap: 10px;
}
</style>
